module.exports = __webpack_public_path__ + "static/media/utilities.ee16d733.svg";